export const mascot = [
  'Lions',
  'Tigers',
  'Wolves',
  'Cobras',
  'Hawks',
  'Eagles',
  'Jaguars',
  'Bulls',
  'Panthers',
  'Sharks',
  'Gorillas',
];

export const kitSize = [
  'Small',
  'Medium',
  'Large',
  'XLarge',
  'XXLarge',
  'XXXLarge',
];

export const KnowsUsFrom = ['Social Media', 'WhatsApp', 'Other'];

export const preferredFoot = ['Left', 'Right', 'Both'];

export const skills = [
  'Pace',
  'Finishing',
  'Crossing',
  'Dribbling',
  'Stamina',
  'Tackling',
  'Reflexes (GK)',
  'Diving (GK)',
];

export const ability = ['Beginner', 'Intermediate', 'Advanced'];

export const position = [
  'GK',
  'SW',
  'CB',
  'RB',
  'RWB',
  'LB',
  'CDM',
  'CM',
  'RM',
  'LM',
  'LW',
  'RW',
  'CF',
  'ST',
  'LWB',
];

export const hometown = [
  'Alexandria',
  'Maadi',
  'Zamalek',
  'Downtown',
  'Dokki',
  'Mohandessin',
  '6th Of October',
  'Heliopolis',
  'Nasr City',
  'New Cairo',
  'Rehab',
  'Mokattam',
  'Sherouk',
  'Obour',
];

export const sportTypes = ['Handball']; //'Handball', 'Football', 'Padel', 'Basketball', 'Volleyball', 'Tennis'

export const paymentPlan = {
  half: 'Half Season',
  full: 'Full Season',
  'free-agent': 'Free Agent',
};

export const returnStatistics = (locale: 'en' | 'ar' = 'en') => {
  const statisticsArr = [
    {
      en: 'Ball Possession',
      ar: 'امتلاك الكرة',
    },
    {
      en: 'Goal Attempts',
      ar: 'محاولات التهديف',
    },
    {
      en: 'Shots on Goal',
      ar: 'تسديدات على المرمى',
    },
    {
      en: 'Shots off Goal',
      ar: 'تسديدات خارج المرمى',
    },
    {
      en: 'Blocked Shots',
      ar: 'تسديدات غير ناجحة',
    },
    {
      en: 'Free Kicks',
      ar: 'الركلات الحرة',
    },
    {
      en: 'Corner Kicks',
      ar: 'الركلات الجانبية',
    },
    {
      en: 'Offsides',
      ar: 'تسلل',
    },
    {
      en: 'Goalkeeper Saves',
      ar: 'إنقاذ من حارس المرمي',
    },
    {
      en: 'Fouls',
      ar: 'الأخطاء',
    },
    {
      en: 'Yellow Cards',
      ar: 'بطاقات صفراء',
    },
    {
      en: 'Red Cards',
      ar: 'بطاقات حمراء',
    },
    {
      en: 'Total Passes',
      ar: 'إجمالي التمريرات',
    },
    {
      en: 'Tackles',
      ar: 'إعتراض الكرة',
    },
    {
      en: 'Attacks',
      ar: 'الهجمات',
    },
    {
      en: 'Dangerous Attacks',
      ar: 'هجمات خطيرة',
    },
    {
      en: 'Completed Passes',
      ar: 'التمريرات المكتملة',
    },
    {
      en: 'Throw-in',
      ar: 'رمية جانبية',
    },
  ];
  return statisticsArr.filter((x) => x[locale]);
};

export const formations = [
  '4-3-3',
  '4-3-2-1',
  '4-4-2',
  '4-5-1',
  '3-5-2',
  '3-4-3',
  '5-3-2',
  '4-2-2-2',
  '4-2-3-1',
];

export const DellComps = [
  'Football',
  'Volley',
  'Padel',
  'Fitness',
  'Dodgeball Men',
  'Dodgeball Women',
  'Pingpong',
  'Backgammon',
  'Chess',
  'Basketball Men',
  'Basketball Women',
  'Baby Foot',
];

export const sports = {
  football: [
    'Dribbling',
    'Passing',
    'Shooting',
    'Defending',
    'Ball Control',
    'Tactical Awareness',
    'Stamina',
    'Agility',
  ],
  basketball: [
    'Dribbling',
    'Passing',
    'Shooting',
    'Defending',
    'Rebounding',
    'Tactical Awareness',
    'Stamina',
    'Agility',
  ],
  handball: [
    'Throwing',
    'Catching',
    'Dribbling',
    'Defending',
    'Shooting',
    'Tactical Awareness',
    'Stamina',
    'Agility',
  ],
  volleyball: [
    'Serving',
    'Passing',
    'Setting',
    'Spiking',
    'Blocking',
    'Digging',
    'Agility',
    'Team Coordination',
  ],
  tennis: [
    'Serving',
    'Forehand',
    'Backhand',
    'Volleying',
    'Footwork',
    'Stamina',
    'Agility',
    'Tactical Awareness',
  ],
};

export const provinces = [
  ...Array.from(
    new Set([
      '15 May',
      'Al Azbakeyah',
      'Al Basatin',
      'Tebin',
      'El-Khalifa',
      'El darrasa',
      'Aldarb Alahmar',
      'Zawya al-Hamra',
      'El-Zaytoun',
      'Sahel',
      'El Salam',
      'Sayeda Zeinab',
      'El Sharabeya',
      'Shorouk',
      'El Daher',
      'Ataba',
      'New Cairo',
      'El Marg',
      'Ezbet el Nakhl',
      'Matareya',
      'Maadi',
      'Maasara',
      'Mokattam',
      'Manyal',
      'Mosky',
      'Nozha',
      'Waily',
      'Bab al-Shereia',
      'Bolaq',
      'Garden City',
      'Hadayek El-Kobba',
      'Helwan',
      'Dar Al Salam',
      'Shubra',
      'Tura',
      'Abdeen',
      'Abaseya',
      'Ain Shams',
      'Nasr City',
      'New Heliopolis',
      'Masr Al Qadima',
      'Mansheya Nasir',
      'Badr City',
      'Obour City',
      'Cairo Downtown',
      'Zamalek',
      'Kasr El Nile',
      'Rehab',
      'Katameya',
      'Madinty',
      'Rod Alfarag',
      'Sheraton',
      'El-Gamaleya',
      '10th of Ramadan City',
      'Helmeyat Alzaytoun',
      'New Nozha',
      'Capital New',
      'Giza',
      'Sixth of October',
      'Cheikh Zayed',
      'Hawamdiyah',
      'Al Badrasheen',
      'Saf',
      'Atfih',
      'Al Ayat',
      'Al-Bawaiti',
      'ManshiyetAl Qanater',
      'Oaseem',
      'Kerdasa',
      'Abu Nomros',
      'Kafr Ghati',
      'Manshiyet Al Bakari',
      'Dokki',
      'Agouza',
      'Haram',
      'Warraq',
      'Imbaba',
      'Boulaq Dakrour',
      'Al Wahat Al Baharia',
      'Omraneya',
      'Moneeb',
      'Bin Alsarayat',
      'Kit Kat',
      'Mohandessin',
      'Faisal',
      'Abu Rawash',
      'Hadayek Alahram',
      'Haraneya',
      'Hadayek October',
      'Saft Allaban',
      'Smart Village',
      'Ard Ellwaa',
      'Abu Qir',
      'Al Ibrahimeyah',
      'Azarita',
      'Anfoushi',
      'Dekheila',
      'El Soyof',
      'Ameria',
      'El Labban',
      'Al Mafrouza',
      'El Montaza',
      'Mansheya',
      'Naseria',
      'Ambrozo',
      'Bab Sharq',
      'Bourj Alarab',
      'Stanley',
      'Smouha',
      'Sidi Bishr',
      'Shads',
      'Gheet Alenab',
      'Fleming',
      'Victoria',
      'Camp Shizar',
      'Karmooz',
      'Mahta Alraml',
      'Mina El-Basal',
      'Asafra',
      'Agamy',
      'Bakos',
      'Boulkly',
      'Cleopatra',
      'Glim',
      'Al Mamurah',
      'Al Mandara',
      'Moharam Bek',
      'Elshatby',
      'Sidi Gaber',
      'North Coast/sahel',
      'Alhadra',
      'Alattarin',
      'Sidi Kerir',
      'Elgomrok',
      'Al Max',
      'Marina',
      'Mansoura',
      'Talkha',
      'Mitt Ghamr',
      'Dekernes',
      'Aga',
      'Menia El Nasr',
      'Sinbillawin',
      'El Kurdi',
      'Bani Ubaid',
      'Al Manzala',
      "tami al'amdid",
      'aljamalia',
      'Sherbin',
      'Mataria',
      'Belqas',
      'Meet Salsil',
      'Gamasa',
      'Mahalat Damana',
      'Nabroh',
      'Hurghada',
      'Ras Ghareb',
      'Safaga',
      'El Qusiar',
      'Marsa Alam',
      'Shalatin',
      'Halaib',
      'Aldahar',
      'Damanhour',
      'Kafr El Dawar',
      'Rashid',
      'Edco',
      'Abu al-Matamir',
      'Abu Homs',
      'Delengat',
      'Mahmoudiyah',
      'Rahmaniyah',
      'Itai Baroud',
      'Housh Eissa',
      'Shubrakhit',
      'Kom Hamada',
      'Badr',
      'Wadi Natrun',
      'New Nubaria',
      'Alnoubareya',
      'Fayoum',
      'Fayoum El Gedida',
      'Tamiya',
      'Snores',
      'Etsa',
      'Epschway',
      'Yusuf El Sediaq',
      'Hadqa',
      'Atsa',
      'Algamaa',
      'Sayala',
      'Tanta',
      'Al Mahalla Al Kobra',
      'Kafr El Zayat',
      'Zefta',
      'El Santa',
      'Qutour',
      'Basion',
      'Samannoud',
      'Ismailia',
      'Fayed',
      'Qantara Sharq',
      'Qantara Gharb',
      'El Tal El Kabier',
      'Abu Sawir',
      'Kasasien El Gedida',
      'Nefesha',
      'Sheikh Zayed',
      'Shbeen El Koom',
      'Sadat City',
      'Menouf',
      'Sars El-Layan',
      'Ashmon',
      'Al Bagor',
      'Quesna',
      'Berkat El Saba',
      'Tala',
      'Al Shohada',
      'Minya',
      'Minya El Gedida',
      'El Adwa',
      'Magagha',
      'Bani Mazar',
      'Mattay',
      'Samalut',
      'Madinat El Fekria',
      'Meloy',
      'Deir Mawas',
      'Abu Qurqas',
      'Ard Sultan',
      'Banha',
      'Qalyub',
      'Shubra Al Khaimah',
      'Al Qanater Charity',
      'Khanka',
      'Kafr Shukr',
      'Tukh',
      'Qaha',
      'Obour',
      'Khosous',
      'Shibin Al Qanater',
      'Mostorod',
      'El Kharga',
      'Paris',
      'Mout',
      'Farafra',
      'Balat',
      'Dakhla',
      'Suez',
      'Alganayen',
      'Ataqah',
      'Ain Sokhna',
      'Faysal',
      'Aswan',
      'Aswan El Gedida',
      'Drau',
      'Kom Ombo',
      'Nasr Al Nuba',
      'Kalabsha',
      'Edfu',
      'Al-Radisiyah',
      'Al Basilia',
      'Al Sibaeia',
      'Abo Simbl Al Siyahia',
      'Marsa Alam',
      'Assiut',
      'Assiut El Gedida',
      'Dayrout',
      'Manfalut',
      'Qusiya',
      'Abnoub',
      'Abu Tig',
      'El Ghanaim',
      'Sahel Selim',
      'El Badari',
      'Sidfa',
      'Bani Sweif',
      'Beni Suef El Gedida',
      'Al Wasta',
      'Naser',
      'Ehnasia',
      'beba',
      'Fashn',
      'Somasta',
      'Alabbaseri',
      'Mokbel',
      'PorSaid',
      'Port Fouad',
      'Alarab',
      'Zohour',
      'Alsharq',
      'Aldawahi',
      'Almanakh',
      'Mubarak',
      'Damietta',
      'New Damietta',
      'Ras El Bar',
      'Faraskour',
      'Zarqa',
      'alsaru',
      'alruwda',
      'Kafr El-Batikh',
      'Azbet Al Burg',
      'Meet Abou Ghalib',
      'Kafr Saad',
      'Zagazig',
      'Al Ashr Men Ramadan',
      'Minya Al Qamh',
      'Belbeis',
      'Mashtoul El Souq',
      'Qenaiat',
      'Abu Hammad',
      'El Qurain',
      'Hehia',
      'Abu Kabir',
      'Faccus',
      'El Salihia El Gedida',
      'Al Ibrahimiyah',
      'Deirb Negm',
      'Kafr Saqr',
      'Awlad Saqr',
      'Husseiniya',
      'san alhajar alqablia',
      'Manshayat Abu Omar',
      'Al Toor',
      'Sharm El-Shaikh',
      'Dahab',
      'Nuweiba',
      'Taba',
      'Saint Catherine',
      'Abu Redis',
      'Abu Zenaima',
      'Ras Sidr',
      'Kafr El Sheikh',
      'Kafr El Sheikh Downtown',
      'Desouq',
      'Fooh',
      'Metobas',
      'Burg Al Burullus',
      'Baltim',
      'Masief Baltim',
      'Hamol',
      'Bella',
      'Riyadh',
      'Sidi Salm',
      'Qellen',
      'Sidi Ghazi',
      'Marsa Matrouh',
      'El Hamam',
      'Alamein',
      'Dabaa',
      'Al-Nagila',
      'Sidi Brani',
      'Salloum',
      'Siwa',
      'Marina',
      'North Coast',
      'Luxor',
      'New Luxor',
      'Esna',
      'New Tiba',
      'Al ziynia',
      'Al Bayadieh',
      'Al Qarna',
      'Armant',
      'Al Tud',
      'Qena',
      'New Qena',
      'Abu Tesht',
      'Nag Hammadi',
      'Deshna',
      'Alwaqf',
      'Qaft',
      'Naqada',
      'Farshout',
      'Quos',
      'Arish',
      'Sheikh Zowaid',
      'Nakhl',
      'Rafah',
      'Bir al-Abed',
      'Al Hasana',
      'Sohag',
      'Sohag El Gedida',
      'Akhmeem',
      'Akhmim El Gedida',
      'Albalina',
      'El Maragha',
      "almunsha'a",
      'Dar AISalaam',
      'Gerga',
      'Jahina Al Gharbia',
      'Saqilatuh',
      'Tama',
      'Tahta',
      'Alkawthar',
    ])
  ),
];
